<template>
    <div>
        <b-row role="alert">
            <b-col>
                <div class="sr-only" v-if="isLoading">Pending applications loading, please wait...</div>
            </b-col>
        </b-row>
        <b-table hover small responsive show-empty
                 class="sr-caption"
                 aria-live="polite"
                 :id="slug"
                 :fields="fields"
                 :items="items"
                 primary-key="id"
                 :busy="isLoading"
                 :tbody-tr-class="highlightReturnedOrDraft"
                 caption="User's Application table.  To sort the data in this table by a specific column,
                            go to the appropriate column header cell and use enter to sort the data ascending.
                            Use enter again to sort descending.">
            <template v-slot:cell(actions)="row">
                <div v-if="row.item.applicationType.code==='R'">
                  <b-button v-if="row.item.status.includes('Draft')" size="sm" href="/renew" variant="primary" class="mr-1">Continue</b-button>
                  <b-button v-if="row.item.status.includes('Draft')" size="sm" variant="danger" class="mr-1" @click="deleteDraft">Delete</b-button>
                  <b-button v-else-if="row.item.status==='RETURNED'" size="sm" @click="resubmitApplication(row.item)"
                            variant="primary"
                            class="mr-1">Review/Resubmit</b-button>
                    <b-button v-else size="sm" @click="viewApplication(row.item)"
                              variant="primary"
                              class="mr-1">View</b-button>

                </div>
                <div v-if="row.item.applicationType.code==='I'">
                    <b-button v-if="row.item.status!=='RETURNED'" size="sm" @click="viewApplicationInterstate(row.item)"
                              variant="primary"
                              class="mr-1">View</b-button>
                    <b-button v-else size="sm" @click="resubmitApplicationInterstate(row.item)"
                              variant="primary"
                              class="mr-1">Review/Resubmit</b-button>
                </div>
            </template>
            <template v-slot:cell(submittedDate)="row">
                {{formatDateTime(row.item.submittedDate)}}
            </template>
            <template v-slot:cell(approvalDate)="row">
                {{formatDate(row.item.approvalDate)}}

            </template>
            <template v-slot:cell(unreadNoteCount)="row" >
                <div class="text-center" v-if="row.item.unreadNoteCount>0">
                    <div v-if="row.item.applicationType.code==='R'">
                        <b-button class="btn position-relative btn-primary-outline" size="sm" @click="viewApplication(row.item)">
                            <b-icon icon="envelope-open" class="" variant="warning"/>
                            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white">{{row.item.unreadNoteCount}}</span>
                        </b-button>
                    </div>
                    <div v-if="row.item.applicationType.code==='I'">
                        <b-button class="btn position-relative btn-primary-outline" size="sm" @click="viewApplicationInterstate(row.item)">
                            <b-icon icon="envelope-open" class="" variant="warning"/>
                            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white">{{row.item.unreadNoteCount}}</span>
                        </b-button>
                    </div>
                </div>
            </template>
            <template v-slot:no-data>
                <b-button color="primary" @click="initialize">Reset</b-button>
            </template>
            <template v-slot:empty="scope">
                <p>No applications found for this work queue.</p>
            </template>
            <div slot="table-busy" class="center-text text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                           label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>
        </b-table>

    </div>
</template>
<style>
    .btn-primary-outline {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    .btn-primary-outline:hover {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
</style>
<script>
    import moment from 'moment';
    import axios from "axios";

    export default {
        name: "ApplicantTableList",

        props:{
            items: Array,
            slug: [String],
            isLoading: Boolean,
        },
        data:() => ({
            fields:[
                {key: 'type', label: 'Application Type', sortable:true},
                {key: 'submittedDate', label:'Submitted Date', sortable:true},
                {key: 'approvalDate',label: 'Approved Date', sortable:true},
                {key: 'status', label: 'Status', sortable:true},
                {key: 'unreadNoteCount', label: 'Unread Messages', sortable:true, class:'text-center'},
                {key: 'actions', label:'Actions', sortable:false}
            ]
        }),
        methods:{
            viewApplication(item){
                this.$router.push({path: `/view-renewal/${item.applicationId}`});
            },
            resubmitApplication(item){
                this.$router.push({path: `/resubmit-renewal/${item.applicationId}`});
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
            formatDateTime(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY hh:mmA")
            },
            highlightReturnedOrDraft(item,type){
                return (item != null && (item.status==='Returned' || item.status.includes('Draft'))) ? 'table-warning' : '';
            },

            viewApplicationInterstate(item){
                this.$router.push({path: `/view-endorsement/${item.applicationId}`});
            },
            resubmitApplicationInterstate(item){
                this.$router.push({path: `/resubmit-endorsement/${item.applicationId}`});
            },
            deleteDraft(){
              axios.delete(`${process.env.VUE_APP_API_BASE_URL}/application/draft`)
                  .then(response => {
                    this.showRootToast('Draft deleted', 'Your draft renewal application has been successfully deleted', 'success')
                  })
                  .catch(error=>{
                    this.showRootToast('Issue deleting draft', '', 'danger')
                  })
            },
          showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              noAutoHide: true
            })
            this.toastFocus()
          },
          toastFocus() {
            setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length - 1]
              elem.focus()
            }, 100)
          },
        }
    }
</script>

<style scoped>

</style>